module.exports = __webpack_public_path__ + "static/media/tournament-start-2.a01a5145.mp3";